module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agenda"
  }, [_c('page-bar'), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-8"
  }, [_c('school-class-list', {
    attrs: {
      "label": 'Qual turma irá preparar a agenda?',
      "value": _vm.agenda.class,
      "required": false,
      "filter": '0'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Qual o dia da agenda?")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "format": "dd/MM/yyyy",
      "clearable": false
    },
    on: {
      "change": _vm.setAgendaDate
    },
    model: {
      value: (_vm.datepicker.selected),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "selected", $$v)
      },
      expression: "datepicker.selected"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classes.selected.schoolClassId),
      expression: "classes.selected.schoolClassId"
    }],
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('class-name', {
    class: 'pull-left'
  }), _vm._v(" "), _c('create-homework-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1' || _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio'),
      expression: "classLevel === 'Infantil' || classLevel === 'Fundamental_1' || classLevel === 'Fundamental_2' || classLevel === 'EnsinoMedio'"
    }],
    class: 'pull-right'
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "portlet light no-margin",
    attrs: {
      "id": "homework-list"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.homeworkVisible),
      expression: "homeworkVisible"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1' || _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio'),
      expression: "classLevel === 'Infantil' || classLevel === 'Fundamental_1' || classLevel === 'Fundamental_2' || classLevel === 'EnsinoMedio'"
    }],
    staticClass: "portlet light no-margin"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Cadastro de lições de casa:")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("OBS.: As lições de casa salvas serão replicadas para todos os alunos.")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group"
  }, [_c('create-homework-theme')], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-details"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Selecione o aluno que deseja preencher a agenda:")]), _vm._v(" "), _c('students', {
    class: 'no-margin',
    attrs: {
      "context": 'agenda',
      "imglist": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "height30"
  }, [(_vm.agenda.agenda.status !== 'NOT_CREATED') ? _c('button', {
    staticClass: "btn green-jungle pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishAll
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar todas agendas")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.student.studentId),
      expression: "student.studentId"
    }],
    staticClass: "portlet light",
    attrs: {
      "id": "agenda-details"
    }
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('student-name')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6 border-left"
  }, [_c('student-presence')], 1), _vm._v(" "), (_vm.presence !== 'ABSENT') ? _c('div', {
    staticClass: "col-md-6 col-xs-12 text-right"
  }, [_c('student-humor')], 1) : _vm._e()])]), _vm._v(" "), (_vm.presence !== 'ABSENT') ? _c('div', {
    staticClass: "portlet-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('agenda-editors')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('agenda-viewers')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr'), _vm._v(" "), _c('tabs', {
    model: {
      value: (_vm.activeTabs),
      callback: function($$v) {
        _vm.activeTabs = $$v
      },
      expression: "activeTabs"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Saúde"
    }
  }, [_c('health')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Alimentação",
      "disabled": _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio'
    }
  }, [_c('alimentation')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Atividades & Lição de casa"
    }
  }, [_c('activities')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Lição de casa exclusiva",
      "disabled": _vm.classLevel === 'Bercario'
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "alert alert-info m-b-20"
  }, [_vm._v("As lições de casa cadastradas abaixo sobrescreverão a lição cadastrada para a turma do aluno.")]), _vm._v(" "), _c('create-homework-theme', {
    attrs: {
      "context": 'exclusiveHomework'
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Questões para Indicadores",
      "disabled": _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio'
    }
  }, [_c('questions')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Outros"
    }
  }, [_c('others')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Mensagens"
    }
  }, [_c('highlight')], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "pull-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-save pull-right m-r-100"
  }, [_c('button', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])]), _vm._v(" "), (!(_vm.agenda.agenda.status === 'NOT_CREATED' || _vm.agenda.agenda.status === 'READED' || _vm.agenda.agenda.status === 'SENT' || _vm.agenda.agenda.status === 'APPROVED')) ? _c('button', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publish
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar")])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77146de6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/agenda/agenda.vue
// module id = 1088
// module chunks = 1